import { Typography, Card, Button, ButtonProps } from 'antd';
import { FunctionComponent } from 'react';
import { SampleGroupLink } from 'packages/task-man/components/sample-group-task-queues/sample-group-link';

export const QueueButton: FunctionComponent<
  ButtonProps & {
    text: string;
    queueName?: string | null;
    sampleGroupToken?: string;
    nTasks?: number;
  }
> = ({
  onClick,
  disabled,
  queueName,
  sampleGroupToken,
  nTasks,
  text,
  type,
  loading,
}) => {
  return (
    <div
      key={`${queueName}-sample-group-queue`}
      style={{
        borderRadius: 6,
        background: 'white',
        height: 'auto',
        width: 320,
        padding: '1rem 0',
        border: '1px solid #f0f0f0',
      }}
    >
      <Card
        style={{
          height: 128,
          width: 320,
          border: 'none',
          background: 'none ',
        }}
        title={
          <Typography.Title
            level={3}
            style={{
              margin: '0 0 0.5rem 0',
              wordWrap: 'break-word',
              wordBreak: 'break-all',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
              textAlign: 'left',
              height: 120,
            }}
          >
            {queueName ?? ''}
            {sampleGroupToken && (
              <>
                {' '}
                <SampleGroupLink
                  sampleGroupToken={sampleGroupToken}
                  sampleGroupName={queueName}
                  onClick={(event) => event.stopPropagation()}
                />
              </>
            )}
          </Typography.Title>
        }
      />

      <div
        style={{
          display: 'flex',
          alignItems: 'start',
          height: '100%',
          padding: '0.25rem 1rem 0 1rem',
          flexWrap: 'wrap',
        }}
      >
        <Button
          data-testid={`queue-button-${queueName}`}
          data-count={nTasks ?? 0}
          onClick={onClick}
          role="navigation"
          disabled={disabled}
          type={type}
          loading={loading}
        >
          {text}
        </Button>
        <div
          style={{ width: '280px', textAlign: 'left', margin: '1rem 0 0 0' }}
        >
          <Typography.Text type="secondary" style={{ fontSize: '1rem' }}>
            Available Tasks
          </Typography.Text>
          <Typography.Text
            style={{ fontSize: '1.05rem', marginLeft: '0.5rem' }}
          >
            {nTasks ?? 0}
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};
